import React from 'react';
import PropTypes from 'prop-types';

const ProgressIndicator = ({ tasksProcessed, totalTasksToProcess }) => {
	if (totalTasksToProcess === 0) return null;

	const percentage = Math.min(
		100,
		Math.round((tasksProcessed / totalTasksToProcess) * 100)
	);

	return (
		<div className='mt-2 mb-4'>
			<div className='flex justify-between text-xs mb-1'>
				<span>
					Processing tasks: {tasksProcessed} of {totalTasksToProcess}
				</span>
				<span>{percentage}%</span>
			</div>
			<div className='h-2 bg-gray-200 rounded-full'>
				<div
					className='h-full bg-blue-600 rounded-full transition-all duration-300'
					style={{ width: `${percentage}%` }}
				/>
			</div>
		</div>
	);
};

ProgressIndicator.propTypes = {
	tasksProcessed: PropTypes.number.isRequired,
	totalTasksToProcess: PropTypes.number.isRequired,
};

export default ProgressIndicator;
